export default __webpack_public_path__ + "static/media/dashboard.543dec22.svg";